export const AI_ASSISTANT_WIDTH_STORAGE_KEY = "depozen:ai-assistant-panel-width";
export const AI_ASSISTANT_WIDTH_MIN = 280;
export const AI_ASSISTANT_WIDTH_MAX = 720;
export const AI_ASSISTANT_WIDTH_DEFAULT = 448;
const AI_ASSISTANT_WIDTH_STYLE_ID = "depozen-ai-assistant-panel-width";

export function clampAiAssistantWidthPx(px, { min = AI_ASSISTANT_WIDTH_MIN } = {}) {
  return Math.min(AI_ASSISTANT_WIDTH_MAX, Math.max(min, Math.round(px)));
}

export function readStoredAiAssistantWidthPx() {
  const stored = localStorage.getItem(AI_ASSISTANT_WIDTH_STORAGE_KEY);
  if (!stored) return null;

  const px = parseInt(stored, 10);
  if (Number.isNaN(px)) return null;

  return clampAiAssistantWidthPx(px);
}

function writeAiAssistantWidthToDom(px, { instant = false } = {}) {
  const value = `${px}px`;
  document.documentElement.style.setProperty("--ai-assistant-panel-width", value);

  let styleEl = document.getElementById(AI_ASSISTANT_WIDTH_STYLE_ID);
  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = AI_ASSISTANT_WIDTH_STYLE_ID;
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = `html{--ai-assistant-panel-width:${value}!important;}`;

  if (instant) {
    document.querySelector(".workflow-step-shell--with-ai-assistant")?.classList.add("workflow-step-shell--instant-ai-width");
    requestAnimationFrame(() => {
      document
        .querySelector(".workflow-step-shell--with-ai-assistant")
        ?.classList.remove("workflow-step-shell--instant-ai-width");
    });
  }
}

export function applyAiAssistantWidthPx(px, { persist = false, instant = false, min = AI_ASSISTANT_WIDTH_MIN } = {}) {
  if (px == null) {
    if (persist) localStorage.removeItem(AI_ASSISTANT_WIDTH_STORAGE_KEY);
    document.getElementById(AI_ASSISTANT_WIDTH_STYLE_ID)?.remove();
    document.documentElement.style.removeProperty("--ai-assistant-panel-width");
    return null;
  }

  const clamped = clampAiAssistantWidthPx(px, { min });
  writeAiAssistantWidthToDom(clamped, { instant });
  if (persist) localStorage.setItem(AI_ASSISTANT_WIDTH_STORAGE_KEY, String(clamped));
  return clamped;
}

export function applyStoredAiAssistantWidth() {
  const stored = readStoredAiAssistantWidthPx();
  if (stored == null) return;

  applyAiAssistantWidthPx(stored, { persist: false });
}
